(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityUserPermissions', EntityUserPermissions);

    EntityUserPermissions.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvEntityUserPermissions
     *
     * @description
     * Shows user permissions for the provided entity and provides user interface for editing.
     *
     * If the entity template assigned to the entity changes from one with an EntityType of 'User'
     * to something else, the user-specific properties on the entity are removed. If the entity
     * template changes to one with EntityType of 'User', default user-specific properties are added.
     */
    function EntityUserPermissions() {
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/entity-user-permissions.tmpl.html',
            scope: {
                entity: '=',
                activityPermissions: '='
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            scope.$watch('entity.EntityTemplate', function (newTemplate, oldTemplate) {
                if (!_.isNil(scope.entity) && !_.isNil(scope.entity.EntityTemplate)) {
                    if (angular.isDefined(oldTemplate) && oldTemplate !== null && newTemplate !== null && oldTemplate.EntityType === 'User' && newTemplate.EntityType !== 'User') {
                        // Remove properties for 'User' entity type
                        _.forOwn(defaultUserProperties, function (val, key) {
                            delete scope.entity[key];
                        });
                    } else if (angular.isDefined(newTemplate) && newTemplate !== null && newTemplate.EntityType === 'User') {
                        // Add default properties for 'User' entity type
                        // Merge to an intermediate object to ensure any existing values are preserved
                        var intermediateMerge = {};
                        angular.merge(intermediateMerge, defaultUserProperties, scope.entity);
                        angular.merge(scope.entity, intermediateMerge);
                    }
                }
            });

            var defaultUserProperties = {
                ActivityPermissions: []
            };

            scope.hasPermission = function (p) {
                if (!scope.entity || !scope.entity.ActivityPermissions) {
                    return false;
                }
                return scope.entity.ActivityPermissions.indexOf(p) > -1;
            };

            scope.togglePermission = function (p) {
                if (!scope.entity || !scope.entity.ActivityPermissions) {
                    return;
                }

                var idx = scope.entity.ActivityPermissions.indexOf(p);
                if (idx > -1) {
                    scope.entity.ActivityPermissions.splice(idx, 1);
                } else {
                    scope.entity.ActivityPermissions.push(p);
                }
            };
        }
    }

})();